import { apiGetUserConfig, apiSaveUserConfig } from '@/api/roster';

const TAB_FEATURE_SWITCH_KEY = 'ehr.tab-feature.enabled';
const TAB_FEATURE_SWITCH_CODE = 'tab_switch_state';

function parseTabFeatureEnabled(config: unknown): boolean | undefined {
  const value =
    config && typeof config === 'object' && 'config' in config
      ? (config as { config?: unknown }).config
      : config;

  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value !== 'string') {
    return undefined;
  }
  if (value === '1' || value === 'true') {
    return true;
  }
  if (value === '0' || value === 'false') {
    return false;
  }

  try {
    const parsed = JSON.parse(value);
    return parseTabFeatureEnabled(parsed);
  } catch {
    return undefined;
  }
}

export function isTabFeatureEnabled(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }
  const value = window.localStorage.getItem(TAB_FEATURE_SWITCH_KEY);
  return value !== '0';
}

export function setTabFeatureEnabled(enabled: boolean) {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.setItem(TAB_FEATURE_SWITCH_KEY, enabled ? '1' : '0');
}

export async function loadTabFeatureEnabled() {
  try {
    const response = await apiGetUserConfig({ code: TAB_FEATURE_SWITCH_CODE });
    const enabled = parseTabFeatureEnabled(response);
    if (typeof enabled === 'boolean') {
      setTabFeatureEnabled(enabled);
      return enabled;
    }
  } catch (error) {
    console.warn('Failed to load tab switch state:', error);
  }

  return isTabFeatureEnabled();
}

export async function saveTabFeatureEnabled(enabled: boolean) {
  setTabFeatureEnabled(enabled);
  try {
    await apiSaveUserConfig({
      code: TAB_FEATURE_SWITCH_CODE,
      config: enabled ? '1' : '0',
    });
  } catch (error) {
    console.warn('Failed to save tab switch state:', error);
  }
}
